import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { fetch_comments_by_user } from '../../redux/Thunks/commentsThunk';
import Componentsloader from '../common/componentsloader';
import ActivityItemData from './ActivityItemData'

function UserActivity({isMobileClicked, onClick, user, randomUserID}) {

    const dispatch = useDispatch()
    const [userRecentActivities, setUserRecentActivities] = useState([])
    const [page, setPage] = useState(1)
    const [loading, setLoading] = useState(false)
    const [hasMore, setHasMore] = useState(true)
    const loaderRef = useRef(null)

    let height = userRecentActivities.length < 5 ? "h-[50vh] sm:h-[35vh]" : "h-screen"

    const handleClick = (index) => {
        onClick(index)
    }




    const getCommentsByUser = async () => {
        if (loading || !hasMore) return;

       try {
            setLoading(true);
            const { payload } = await dispatch(
                fetch_comments_by_user({
                    user_id: user?.id,
                    page
                })
            );

            const result = Array.isArray(payload?.results) ? payload?.results : [];

            setUserRecentActivities(prevItems => {
                const existingIds = new Set();
                prevItems.forEach(item => {
                    if (item.eid) existingIds.add(item.eid);
                    if (item.debate_id) existingIds.add(item.debate_id);
                    if (item.discussion_id) existingIds.add(item.discussion_id);
                });

                const uniqueNewItems = result.filter(item => {
                    const hasEid = item.eid && !existingIds.has(item.eid);
                    const hasDebateId = item.debate_id && !existingIds.has(item.debate_id);
                    const hasDiscussionId = item.discussion_id && !existingIds.has(item.discussion_id);
                    return hasEid || hasDebateId || hasDiscussionId;
                });

                return [...prevItems, ...uniqueNewItems];
            });

            setHasMore(payload?.next !== null);
            if (payload?.next) {
                setPage(prev => prev + 1);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }

    }



    useEffect(() => {
        // Reset all States when randomUserID value changes
        setUserRecentActivities([])
        setPage(1)
        setHasMore(true)

        if(user?.id){
            getCommentsByUser()
        }

        // eslint-disable-next-line
    }, [dispatch, user])



    // Intersection Observer effect
    useEffect(() => {
        const currentLoader = loaderRef.current;

        const observer = new IntersectionObserver(
            (entries) => {
                const target = entries[0];
                if (target.isIntersecting && hasMore && !loading) {
                    getCommentsByUser();
                }
            },
            {
                root: null,
                rootMargin: '20px',
                threshold: 0.1
            }
        );

        if (currentLoader) {
            observer.observe(currentLoader);
        }

        return () => {
            if (currentLoader) {
                observer.unobserve(currentLoader);
            }
        };
        // eslint-disable-next-line
    }, [loading, hasMore]);




    return (
        <div className='relative bg-nightModeDark text-white pb-3 lg:px-4 rounded-xl'>
            <p className="font-semibold hidden lg:block p-4">Recent Activity</p>

            <div className='sticky lg:hidden font-semibold flex justify-between'>
                <button
                    onClick={() => handleClick(0)}
                    className={`font-semibold ${!randomUserID ? "w-2/4" : "w-full"} py-3 rounded-tl-md
                    ${isMobileClicked && isMobileClicked[0] ? "bg-nightModeDark": "bg-greenOnDarkMode"}`}
                >
                    Recent Activity
                </button>

                {!randomUserID && (
                    <button
                        onClick={() => handleClick(1)}
                        className={`font-semibold w-2/4 py-3 rounded-tr-md
                        ${isMobileClicked && isMobileClicked[1] ? "bg-nightModeDark": "bg-greenOnDarkMode"}`}
                    >
                        Policy Web
                    </button>
                )}
            </div>

            <div className={`${height} overflow-y-scroll scroll-bar-in-dark text-sm py-5 px-3`}>
                {loading && userRecentActivities.length === 0 ? (
                    <Componentsloader />
                ) : userRecentActivities.length > 0 ? (
                    <>
                        <div>
                            {userRecentActivities.map((item, idx) => {
                                return <div key={idx}>
                                <ActivityItemData  data={item} />
                                </div>
                            })}
                        </div>
                        <div ref={loaderRef} className="h-10 flex items-center justify-center">
                            {loading && <div className="text-white">Loading more...</div>}
                        </div>
                    </>
                ) : (
                    <p className='text-xl text-center'>No Activity</p>
                )}
            </div>
        </div>
    );
}

export default UserActivity
